export interface PwaBadgeProps {
    imageAltText: string;
    imageSrc: string;
}

export const PwaInstallBadge = ({imageAltText, imageSrc} : PwaBadgeProps) => {
    return (
        <img 
            height={94} 
            width={250} 
            alt={imageAltText} 
            src={imageSrc}
        />
    )
}